var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateAndTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 9.5C1.6875 5.46278 4.96278 2.1875 9 2.1875C13.0372 2.1875 16.3125 5.46278 16.3125 9.5C16.3125 13.5372 13.0372 16.8125 9 16.8125C4.96278 16.8125 1.6875 13.5372 1.6875 9.5ZM9 3.3125C5.5841 3.3125 2.8125 6.0841 2.8125 9.5C2.8125 12.9159 5.5841 15.6875 9 15.6875C12.4159 15.6875 15.1875 12.9159 15.1875 9.5C15.1875 6.0841 12.4159 3.3125 9 3.3125Z",
    fill: "#1B2436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.4375C9.31066 4.4375 9.5625 4.68934 9.5625 5V9.5H12.375C12.6857 9.5 12.9375 9.75184 12.9375 10.0625C12.9375 10.3732 12.6857 10.625 12.375 10.625H9C8.68934 10.625 8.4375 10.3732 8.4375 10.0625V5C8.4375 4.68934 8.68934 4.4375 9 4.4375Z",
    fill: "#1B2436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateAndTime);
export default __webpack_public_path__ + "static/media/dateAndTime.be357b8bf12b3c4698222f61e647e838.svg";
export { ForwardRef as ReactComponent };